import React, { FC, Suspense, useMemo } from 'react';
import { Conditional } from 'components/pcc-components';
import ContactDealerTooltip from './contact-dealer-tooltip';
import Price from 'components/price';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { CatSkeleton } from 'components/blocks-components';
import { LineItem } from 'types/parts-diagram';

export interface PartCardPriceProps {
  currency: string;
  partItem: LineItem;
  modifiedPriceData: ProductDealerPriceAvailability;
  className: string;
  isMobileView?: boolean;
  fromProductPage?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  isCatCorp?: boolean;
}

const PartCardPrice: FC<PartCardPriceProps> = ({
  currency,
  partItem,
  modifiedPriceData,
  className,
  fromProductPage,
  isMobileView = false,
  isRTL = false,
  currencyLdFeatureFlag = false,
  isCatCorp = false
}) => {
  const {
    ieSystemControlNumber = null,
    priceAndAvailabilityData,
    partNumber
  } = partItem || {};

  const productPrice = useMemo(() => {
    return (
      <Price
        currency={currency}
        price={
          partNumber === modifiedPriceData?.partNumber
            ? modifiedPriceData
            : priceAndAvailabilityData
        }
        showDiscountSection={fromProductPage}
        isMobileView={isMobileView}
        isRTL={isRTL}
        currencyLdFeatureFlag={currencyLdFeatureFlag}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceAndAvailabilityData]);

  return (
    <Conditional
      test={!!ieSystemControlNumber}
      fallback={
        !isCatCorp &&
        (priceAndAvailabilityData?.enableAddToCart ? (
          <Suspense fallback={modifiedPriceData && <CatSkeleton size="lg" />}>
            <div className={className}>{productPrice}</div>
          </Suspense>
        ) : (
          !isMobileView && <ContactDealerTooltip />
        ))
      }
    />
  );
};

export default PartCardPrice;
